import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { Avatar, Button, Tooltip } from "antd";
import { ReactComponent as Send } from "../../../assets/svg/send2.svg";
import { useCommentPost } from "../../../redux/api/Timeline";
import { isEmpty, Toast } from "../../../lib/helpers/helpers";
import {
	PostComment,
	TextAreaComment,
} from "../TimelineCommentDetails/component";
import errorHandler from "../../../redux/actions/errorHandler";

const Editor = ({ onChange, onSubmit, submitting, value, focus }) => (
	<div tw="flex flex-row flex-nowrap gap-4 w-full items-start">
		<TextAreaComment
			autoSize={{ minRows: 1, maxRows: 3 }}
			onChange={onChange}
			value={value}
			// focus={focus}
			focus={{
				cursor: "start",
			}}
			maxLength={148}
			showCount
			placeholder="Add comment"
		/>

		<Tooltip title="Post" tw="mt-2">
			<Button
				type="text"
				shape="circle"
				icon={
					<Send
						width={32}
						height={36}
						tw="hover:(cursor-pointer)"
						onClick={onSubmit}
					/>
				}
				size="small"
			/>
		</Tooltip>
	</div>
);

const TimelineCommentInput = ({
	timeline,
	avatar,
	focus,
	refetch = () => {
		return null;
	},
}) => {
	const tldata = timeline;

	const [tl, setTl] = useState({});
	useEffect(() => {
		if (isEmpty(tldata)) {
			return;
		}
		setTl(tldata);
	}, [tldata]);

	const [value, setValue] = useState("");

	// eslint-disable-next-line no-unused-vars
	const { mutateAsync: handlePostComment, isLoading } = useCommentPost({});
	const handleSubmit = async () => {
		if (isEmpty(value)) {
			return Toast.fire({
				icon: "error",
				title: "Comment cannot be empty",
			});
		}

		const data = {
			weddingId: tl.weddingId,
			comment_text: value,
			postId: tl.id,
			// invitation_code: "832A2",
		};

		try {
			const res = await handlePostComment(data);
			console.log(res);
			const { hasError, errors } = res;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: res.data,
			});
			setValue("");
			refetch();
		} catch (err) {
			console.log("the pay error", err);
		}
	};
	return (
		<PostComment tw="mt-8">
			<Avatar
				src={avatar || "https://joeschmoe.io/api/v1/random"}
				alt={timeline?.user?.firstname}
				tw="flex flex-col items-center justify-center mr-1"
			/>
			<Editor
				onChange={(e) => setValue(e.target.value)}
				onSubmit={handleSubmit}
				value={value}
				focus={focus}
			/>
		</PostComment>
	);
};

export default TimelineCommentInput;
